import(/* webpackMode: "eager", webpackExports: ["LegalPage"] */ "/app/apps/tagea-web/src/libs/features/legal/ui/LegalPage.tsx");
